var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 35",
    style: {
      enableBackground: "new 0 0 56 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,0H4C1.8,0,0,1.8,0,4v27c0,2.2,1.8,4,4,4h48c2.2,0,4-1.8,4-4V4C56,1.8,54.2,0,52,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9FC",
    d: "M52,35H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4v27C56,33.2,54.2,35,52,35z M4,1 C2.3,1,1,2.3,1,4v27c0,1.7,1.3,3,3,3h48c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_2_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.6587,
    y1: 22.2832,
    x2: 50.9999,
    y2: 22.2832,
    gradientTransform: "matrix(1 0 0 -1 0 35.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077C3"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_2_2_)",
    d: "M37.7,11c0.2,2.9,3,5.2,6.4,5.2c0,0,6.9,0,6.9,0c0.1-0.3,0.1-0.5,0.1-0.8c0-2.4-2-4.4-4.4-4.4H37.7 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#37A72E",
    d: "M50.8,16.9c-0.6,1.7-2.2,2.9-4.1,2.9h-4.5V24h-4v-7.1H50.8z M31,11.8l-3.2,6.8c0,0,0,0.1,0,0.1 c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.3-0.1-0.3-0.3V11h-4v12.9h4c0.5,0,1.1-0.4,1.3-0.8l3.2-6.9c0,0,0,0,0,0c0-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.2,0.1,0.2,0.2v7.7h4V11h-4C31.7,11,31.2,11.4,31,11.8z M17,11c-0.7,0-1.5,0.6-1.7,1.3l-1.9,6.3c-0.1,0.3-0.3,0.3-0.4,0 l-1.9-6.3c-0.2-0.7-1-1.3-1.7-1.3h-1H5v12.9h4v-7.5c0-0.1,0.1-0.3,0.3-0.3c0.1,0,0.2,0.1,0.3,0.2l2.3,7.6h2.9l2.3-7.6 c0-0.1,0.1-0.2,0.3-0.2c0.1,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v7.5h4V11h-3.4H17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.203a0b9e.svg";
export { ForwardRef as ReactComponent };